(function () {
	var INVENTORY_API = 'https://boh-oauth-catcher.fourevergreen.workers.dev/inventory';
	var BOLIG_OG_HAVEN = 'Bolig og Haven';

	function countWeekdays(from, to) {
		var count = 0;
		var cur = new Date(from.getTime());
		cur.setHours(0, 0, 0, 0);
		var end = new Date(to.getTime());
		end.setHours(0, 0, 0, 0);
		while (cur <= end) {
			var day = cur.getDay();
			if (day !== 0 && day !== 6) count++;
			cur.setDate(cur.getDate() + 1);
		}
		return count;
	}

	function getHolidayExtraDays(holidays, today) {
		var totalExtra = 0;
		holidays.forEach(function (holiday) {
			if (!holiday.start || !holiday.end) return;
			var start = new Date(holiday.start + 'T00:00:00');
			var end = new Date(holiday.end + 'T00:00:00');
			var from = today > start ? today : start;
			if (from > end) return;
			totalExtra += countWeekdays(from, end);
		});
		return totalExtra;
	}

	function buildIntervalText(lower, upper, holidays) {
		if (isNaN(lower) || isNaN(upper)) return '';
		var today = new Date();
		today.setHours(0, 0, 0, 0);
		var extra = getHolidayExtraDays(holidays, today);
		return (lower + extra) + '-' + (upper + extra) + ' hverdage';
	}

	function init(container) {
		var textEl = container.querySelector('.delivery-estimate__text');
		var sectionId = container.id.replace('delivery-estimate-', '');
		var quantityInput = document.getElementById('Quantity-' + sectionId);
		var addToCartButtons = document.querySelectorAll('.single-add-to-cart-button, .product-add-to-cart-sticky--inner');

		var holidays = [];
		var holidaysEl = document.getElementById('delivery-holidays-' + sectionId);
		if (holidaysEl) {
			try {
				holidays = JSON.parse(holidaysEl.textContent) || [];
			} catch (e) {
				holidays = [];
			}
		}

		var lower = parseInt(container.dataset.intervalLower, 10);
		var upper = parseInt(container.dataset.intervalUpper, 10);
		var baseLower = parseInt(container.dataset.baseIntervalLower, 10);
		var baseUpper = parseInt(container.dataset.baseIntervalUpper, 10);
		var baseIntervalText = buildIntervalText(baseLower, baseUpper, holidays);

		var state = {
			lokation: container.dataset.lokation || '',
			interval: buildIntervalText(lower, upper, holidays),
			baseInterval: baseIntervalText || 'Dag-til-dag levering',
			inventoryPolicy: container.dataset.inventoryPolicy,
			nativelyAvailable: container.dataset.nativelyAvailable === 'true',
			locations: null,
		};

		function getQuantity() {
			var val = quantityInput ? parseInt(quantityInput.value, 10) : 1;
			return isNaN(val) || val < 1 ? 1 : val;
		}

		function setState(text, enableCart) {
			textEl.textContent = text;
			container.hidden = false;
			container.classList.toggle('delivery-estimate--sold-out', !enableCart);
			if (!state.nativelyAvailable) return;
			addToCartButtons.forEach(function (btn) {
				btn.disabled = !enableCart;
				btn.classList.toggle('delivery-estimate-disabled', !enableCart);
			});
		}

		function clearState() {
			textEl.textContent = '';
			container.hidden = true;
			container.classList.remove('delivery-estimate--sold-out');
		}

		function updateQuantityMax() {
			if (!quantityInput || !state.locations) return;
			if (state.inventoryPolicy === 'continue') {
				quantityInput.removeAttribute('max');
				return;
			}
			var boligHaven = state.locations[BOLIG_OG_HAVEN] || 0;
			var lokationStock = state.lokation ? (state.locations[state.lokation] || 0) : 0;
			var maxQty = boligHaven + lokationStock;
			if (maxQty > 0) {
				quantityInput.setAttribute('max', maxQty);
			} else {
				quantityInput.removeAttribute('max');
			}
		}

		function clampToMax() {
			if (!quantityInput) return;
			var max = quantityInput.getAttribute('max');
			if (max === null || max === '') return;
			var maxVal = parseInt(max, 10);
			var val = parseInt(quantityInput.value, 10);
			if (!isNaN(maxVal) && !isNaN(val) && val > maxVal) {
				quantityInput.value = maxVal;
			}
		}

		function evaluate() {
			if (!state.locations) return;
			var qty = getQuantity();
			var boligHaven = state.locations[BOLIG_OG_HAVEN] || 0;

			if (boligHaven >= qty) {
				setState(state.baseInterval, true);
				return;
			}

			var lokationStock = state.lokation ? (state.locations[state.lokation] || 0) : 0;
			if (boligHaven + lokationStock >= qty) {
				setState(state.interval, true);
				return;
			}

			if (state.inventoryPolicy === 'continue') {
				setState(state.interval, true);
			} else {
				setState('Udsolgt', false);
			}
		}

		function loadForVariant(variantId) {
			if (!variantId) {
				clearState();
				return;
			}
			fetch(INVENTORY_API + '?variant_id=' + variantId)
				.then(function (res) {
					if (!res.ok) throw new Error('bad response');
					return res.json();
				})
				.then(function (data) {
					state.locations = data.locations || {};
					updateQuantityMax();
					evaluate();
				})
				.catch(function () {
					state.locations = null;
					clearState();
				});
		}

		loadForVariant(container.dataset.variantId);

		if (quantityInput) {
			quantityInput.addEventListener('change', function () {
				clampToMax();
				evaluate();
			});
			quantityInput.addEventListener('input', function () {
				clampToMax();
				evaluate();
			});
		}

		document.addEventListener('product:variant-change', function (event) {
			if (event.detail.sectionId !== sectionId) return;
			var variant = event.detail.variant;
			if (!variant) {
				clearState();
				return;
			}
			container.dataset.inventoryPolicy = variant.inventory_policy || variant.inventoryPolicy || '';
			container.dataset.nativelyAvailable = String(!!variant.available);
			state.inventoryPolicy = container.dataset.inventoryPolicy;
			state.nativelyAvailable = container.dataset.nativelyAvailable === 'true';
			loadForVariant(variant.id);
		});
	}

	document.querySelectorAll('.delivery-estimate').forEach(init);
})();
